import { render, staticRenderFns } from "./AdminTableRow.vue?vue&type=template&id=c8c61edc&scoped=true"
import script from "./AdminTableRow.vue?vue&type=script&lang=js"
export * from "./AdminTableRow.vue?vue&type=script&lang=js"
import style0 from "./AdminTableRow.vue?vue&type=style&index=0&id=c8c61edc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8c61edc",
  null
  
)

export default component.exports